<template>
  <div id="through-strategy">
    <div class="section padding-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 col-lg-12 padding-top-big">
            <div class="row">
              <div
                class="col-lg-1 text-right"
                :style="{
                  opacity: `${2.2 - scrollPos / 200}`,
                  top: `${-scrollPos + 300}px`
                }"
              >
                <span> THROUGH STRATEGY TO</span>
              </div>
              <div
                :style="{
                  opacity: `${2.2 - scrollPos / 200}`,
                  top: `${-scrollPos + 300}px`
                }"
                class="col-lg-11"
              >
                <h1 class="no-break">
                  take your <span class="highlight">ideas</span> from
                  <span class="highlight">useful</span> to
                  <span class="highlight">delightful</span>
                </h1>
              </div>
              <div
                :style="{
                  opacity: `${2.2 - scrollPos / 200}`,
                  top: `${-scrollPos + 300}px`
                }"
                class="offset-2 col-10 mt-2 mt-sm-3"
              >
                <p>
                  I offer analysis, solutions, and general marketing expertise
                  to help you successfully
                  <span class="highlight">brand!</span> and market your
                  products.
                </p>
              </div>
              <div class="offset-3 col-9 mt-2 mt-sm-3">
                <div class="stratgy-image"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ParallaxEffect, scrollPosition } from "@/components/utils";
export default {
  data() {
    return {
      scrollPos: null,
      scrollingAnimation: null
    };
  },
  mounted() {
    ParallaxEffect(this.$el);
    window.addEventListener(
      "scroll",
      (this.scrollingAnimation = () =>
        (this.scrollPos = scrollPosition(this.$el)))
    );
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollingAnimation);
  }
};
</script>

<style lang="scss" scoped>
.stratgy-image {
  width: 100%;
  height: 40vh;
  background-size: cover;
  background-image: url(../assets/img/about/strategy.jpg);
  position: relative;
  z-index: -1;
}
</style>
